import HeaderActionButton, { HeaderActionButtonType } from 'modules/POS/Cashier/HeaderActions/HeaderActionButton';
import { cashierCtrl } from 'modules/POS/Cashier/cashier.controller';
import cashierService from 'modules/POS/services';
import { useState } from 'react';
import ModalOnHoldTickets from './Modal';

const OnHoldTickets = () => {
  const [open, setOpen] = useState(false);
  const data = cashierService.selectors.lstBillOnHold();
  const handleClose = () => setOpen(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const onChooseTicket = (billId: string) => {
    setOpen(false);
    cashierCtrl.switchTicket(billId);
  };

  return (
    <>
      <HeaderActionButton
        onClick={handleOpen}
        type={HeaderActionButtonType.ON_HOLD}
        count={data.length}
      />
      <ModalOnHoldTickets
        open={open}
        onClose={handleClose}
        onChooseTicket={onChooseTicket}
      />
    </>
  );
};

export default OnHoldTickets;
